import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { useAuth } from './lib/auth.js';
import AppShell from './layout/AppShell.js';
import LoginRoute from './routes/login.js';
import TodayRoute from './routes/today.js';
import CalendarRoute from './routes/calendar.js';
import MessagesRoute from './routes/messages.js';
import ClientsRoute from './routes/clients.js';
import StudioRoute from './routes/studio.js';
import PilotageRoute from './routes/pilotage.js';
import DemoClientRoute from './routes/demo-client.js';
import DemoProRoute from './routes/demo-pro.js';

export default function App() {
  const { status } = useAuth();
  const location = useLocation();

  // /demo/* is public — used by the two-simulator demo (client side)
  if (location.pathname.startsWith('/demo/')) {
    return (
      <Routes>
        <Route path="/demo/client" element={<DemoClientRoute />} />
        <Route path="/demo/pro" element={<DemoProRoute />} />
        <Route path="/demo/*" element={<Navigate to="/demo/client" replace />} />
      </Routes>
    );
  }

  if (status === 'loading') {
    return (
      <div className="min-h-screen grid place-items-center font-mono text-[var(--text-faint)]">
        Chargement…
      </div>
    );
  }

  if (status === 'unauthenticated') {
    return (
      <Routes>
        <Route path="/login" element={<LoginRoute />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    );
  }

  return (
    <Routes>
      <Route element={<AppShell />}>
        <Route path="/" element={<TodayRoute />} />
        <Route path="/calendar" element={<CalendarRoute />} />
        <Route path="/messages" element={<MessagesRoute />} />
        <Route path="/clients" element={<ClientsRoute />} />
        <Route path="/studio" element={<StudioRoute />} />
        <Route path="/pilotage" element={<PilotageRoute />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
